import React from "react";
import { useTranslation } from "react-i18next";
import AccordionSection from "./AccordionSection";

const IA_OPERATIONAL_SECTION_ORDER = [
  "discoveryMapping",
  "deepInspection",
  "structuralRefactor",
  "massPathFix",
  "safetyBridges",
  "encodingValidation",
  "gitAudit",
  "commitBodyDiscipline",
];

export default function IAOperationalWindowContent() {
  const { t } = useTranslation("aiPortfolio");
  const [openSection, setOpenSection] = React.useState(IA_OPERATIONAL_SECTION_ORDER[0]);

  return (
    <div className="gitflowContent">
      <p className="resumeWindowTitle">{t("windows.ia_operacional.title")}</p>
      <p>{t("iaOperational.summary")}</p>

      {IA_OPERATIONAL_SECTION_ORDER.map((sectionKey, index) => (
        <AccordionSection
          key={sectionKey}
          sectionId={sectionKey}
          openSection={openSection}
          onOpenSection={setOpenSection}
          title={`${index + 1}. ${t(`iaOperational.sections.${sectionKey}.title`)}`}
          className="gitflowSection methodAccordionItem"
        >
          <p className="gitflowSectionSubtitle">{t(`iaOperational.sections.${sectionKey}.subtitle`)}</p>
          <pre className="gitflowCodeBlock">{t(`iaOperational.sections.${sectionKey}.commands`)}</pre>
        </AccordionSection>
      ))}

      <AccordionSection
        sectionId="practicalNotes"
        openSection={openSection}
        onOpenSection={setOpenSection}
        title={`${IA_OPERATIONAL_SECTION_ORDER.length + 1}. ${t("iaOperational.practicalTitle")}`}
        className="gitflowSection methodAccordionItem"
      >
          <ol className="gitflowList">
            {t("iaOperational.practicalNotes", { returnObjects: true }).map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
      </AccordionSection>

      <p>{t("iaOperational.closing")}</p>
    </div>
  );
}
